var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F4F4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4042_18494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#5A81FA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4042_18494)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4042_18494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 24,
    height: 26
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 24,
    height: 25.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4042_18494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 23.8891C21.25 23.8891 22.3125 23.4273 23.1875 22.5037C24.0625 21.5801 24.5 20.4585 24.5 19.1391C24.5 17.8197 24.0625 16.6981 23.1875 15.7745C22.3125 14.8509 21.25 14.3891 20 14.3891V15.9724C20.8333 15.9724 21.5417 16.2803 22.125 16.896C22.7083 17.5118 23 18.2595 23 19.1391C23 20.0187 22.7083 20.7664 22.125 21.3822C21.5417 21.9979 20.8333 22.3058 20 22.3058C19.45 22.3058 18.9375 22.1562 18.4625 21.8572C17.9875 21.5581 17.6167 21.1535 17.35 20.6433L16.05 21.4085C16.45 22.1826 17 22.7896 17.7 23.2294C18.4 23.6692 19.1667 23.8891 20 23.8891ZM16.25 20.0363C16.4667 20.0363 16.6458 19.9616 16.7875 19.812C16.9292 19.6625 17 19.4734 17 19.2447C17 19.016 16.9292 18.8268 16.7875 18.6773C16.6458 18.5278 16.4667 18.453 16.25 18.453C16.0333 18.453 15.8542 18.5278 15.7125 18.6773C15.5708 18.8268 15.5 19.016 15.5 19.2447C15.5 19.4734 15.5708 19.6625 15.7125 19.812C15.8542 19.9616 16.0333 20.0363 16.25 20.0363ZM16.8 17.8197C17.0167 17.8197 17.1958 17.7449 17.3375 17.5954C17.4792 17.4458 17.55 17.2567 17.55 17.028C17.55 16.7993 17.4792 16.6102 17.3375 16.4606C17.1958 16.3111 17.0167 16.2363 16.8 16.2363C16.5833 16.2363 16.4042 16.3111 16.2625 16.4606C16.1208 16.6102 16.05 16.7993 16.05 17.028C16.05 17.2567 16.1208 17.4458 16.2625 17.5954C16.4042 17.7449 16.5833 17.8197 16.8 17.8197ZM18.25 16.3683C18.4667 16.3683 18.6458 16.2935 18.7875 16.144C18.9292 15.9944 19 15.8053 19 15.5766C19 15.3479 18.9292 15.1588 18.7875 15.0092C18.6458 14.8597 18.4667 14.7849 18.25 14.7849C18.0333 14.7849 17.8542 14.8597 17.7125 15.0092C17.5708 15.1588 17.5 15.3479 17.5 15.5766C17.5 15.8053 17.5708 15.9944 17.7125 16.144C17.8542 16.2935 18.0333 16.3683 18.25 16.3683ZM20 30.2224C17.6833 29.6067 15.7708 28.2037 14.2625 26.0134C12.7542 23.8231 12 21.391 12 18.7169V12.278L20 9.11133L28 12.278V18.7169C28 21.391 27.2458 23.8231 25.7375 26.0134C24.2292 28.2037 22.3167 29.6067 20 30.2224ZM20 28.0058C21.7333 27.4252 23.1667 26.2641 24.3 24.5224C25.4333 22.7808 26 20.8456 26 18.7169V13.7294L20 11.3544L14 13.7294V18.7169C14 20.8456 14.5667 22.7808 15.7 24.5224C16.8333 26.2641 18.2667 27.4252 20 28.0058Z",
    fill: "#5A81FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalIcon);
export default __webpack_public_path__ + "static/media/digitalIcon.0645a2e6340db5e9565cd7f052e4557f.svg";
export { ForwardRef as ReactComponent };